<template>
	<router-form
		@submit="submit()"
	></router-form>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

import * as routerModule from '@/store/router/app.js'
import RouterForm from '@/components/router/RouterForm.vue'
import RouterFormValidation from '@/mixins/router-form-validation.js'

export default {
	props: ['id'],

	mixins: [
		RouterFormValidation
	],

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['router/']) {
			this.$store.registerModule('router', routerModule.default)
		}
	},

	async beforeRouteLeave (to, from, next) {
		this.$store.commit('router/clearCreateData')
		next()
	},

	async created () {
		await this.$store.dispatch('router/getRouterInfo', `id=${this.id}`)
		await this.$store.dispatch('router/getBandList', this.id)
		await this.$store.dispatch('router/getClientList', '')

		if (this.routerInfo.id) {
			this.formData.id = this.routerInfo.id
			this.formData.name = this.routerInfo.name

			if (this.routerInfo.client) {
				this.formData.client = this.routerInfo.client
			}

			this.formData.macAddress = this.routerInfo.mac_address
			this.formData.ipAddress = this.routerInfo.ip

			if (this.bands.length) {
				this.formData.bands = []
				this.bands.forEach(item => {
					this.formData.bands.push({
						created_at: item.created_at,
						macAddress: item.mac_address,
						name: item.band_name,
						id: item.id
					})
				})
			} else {
				this.formData.bands = [{
					name: '',
					macAddress: '',
					created_at: new Date(),
				}]
			}
		}
	},

	components: {
		RouterForm
	},

	computed: {
		...mapFields(`router`, {
			formData: 'createForm',
			routerInfo: 'routerInfo',
			bands: 'bands'
		})
	}
}
</script>
